import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import firebase, { base } from './firebase';

const useStyles = makeStyles(theme => ({
    icon: {
        marginRight: theme.spacing(1),
    },
}));

const ReportUpdateComponent: React.FC = () => {
    const classes = useStyles();
    const history = useHistory();
    const { t } = useTranslation();
    const [lastFetch, setLastFetch] = useState<string | null>(null);
    const [credentialsExist, setCredentialsExist] = useState<boolean>(false);
    const userId = firebase.getCurrentUser()?.uid;
    const location = useLocation();
    useEffect(() => {
        // Subscribe to changes in credentials
        const credentialsRef = firebase.db.ref(`${base}/${userId}/amazonCredentials`);
        credentialsRef.on('value', (snapshot: { val: () => any; }) => {
            const credentials = snapshot.val();
            setCredentialsExist(!!credentials); // Set credentialsExist based on whether credentials exist
        });

        // Subscribe to changes in lastFetch
        const lastFetchRef = firebase.db.ref(`${base}/${userId}/lastFetch`);
        lastFetchRef.on('value', (snapshot: { val: () => any; }) => {
            const lastFetchValue = snapshot.val();
            setLastFetch(lastFetchValue); // Update lastFetch state with the value from Firebase
        });

        return () => {
            // Unsubscribe when component unmounts
            credentialsRef.off();
            lastFetchRef.off();
        };
    }, [userId]); // Dependency array ensures useEffect runs only when userId changes
    if (location.pathname === "/dashboard/fetch-reports" || location.pathname === "/credentialsForm") {
        return null; // Render nothing if current route matches hideOnRoute
    }
    return null;
};

export default ReportUpdateComponent;
